import styled from 'styled-components';
import { ScrollBarStyle } from '@slides/styles';
import { Button } from '../styles';

export const PdfThumbnail = styled.div`
    border: 1px solid grey;
    canvas.react-pdf__Page__canvas {
        width: 100% !important;
        height: ${({ pageHeight }) => pageHeight + 'px'} !important;
        cursor: pointer;
    }
    .react-pdf__Page__textContent {
        display: none;
    }
`;

export const PageNumberLabel = styled.p`
    text-align: center;
    font-size: .75rem;
`;

export const PdfDisplayStyle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

// By default, react-pdf makes it difficult to override styles
// such that they distort or stretch the pdf - but we want it to stretch.
export const DocumentStyle = styled.div`
    border: 2px solid grey;
    width: 100%;
    min-width: 600px;
    height: 650px;
    overflow-y: scroll;
    z-index: ${props => props.clientViewing ? '-2' : '0'};
    ${ScrollBarStyle}
    @media (min-width: 850px) {
        width: 850px;
        margin: 0 auto;
    }
    canvas.react-pdf__Page__canvas {
        position: relative;
        top: 0;
        height: 100% !important;
        width: 100% !important;
    }
    .react-pdf__Page__textContent {
        display: none;
    }
`;

export const PdfButtonsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    top: -50px;
    opacity: ${props => props.hoverActive ? '1' : '0'};
    transition: 0.5s ease;
    width: 100%;
    background: #0000008f;
    height: 50px;
    padding: 5px;
    color: #fff;
`;

export const PdfButton = styled(Button)`
    padding: 5px 10px;
    margin: 0 10px;
    width: 8rem;
    height: 100%;
    font-size: ${props => props.theme.smallFont};
    display: flex;
    justify-content: space-between;
    background: ${props => props.theme.darkGrey};
    border-radius: 5px;
    margin-bottom: 0;
`;
